import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year6/Spring/Statistics/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Statistics',
  weeks: [11, 12],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(/* webpackChunkName: "Year6/Spring/Statistics/1LineGraphs" */ './1LineGraphs')
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(/* webpackChunkName: "Year6/Spring/Statistics/2DualBarCharts" */ './2DualBarCharts')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Statistics/3ReadAndInterpretPieCharts" */ './3ReadAndInterpretPieCharts'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Statistics/4PieChartsWithPercentages" */ './4PieChartsWithPercentages'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(/* webpackChunkName: "Year6/Spring/Statistics/5DrawPieCharts" */ './5DrawPieCharts')
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () => import(/* webpackChunkName: "Year6/Spring/Statistics/6TheMean" */ './6TheMean')
    })
  ]
});
export default Block;
